import { render, staticRenderFns } from "./dataProduct.vue?vue&type=template&id=9e6013d8&scoped=true"
import script from "./dataProduct.vue?vue&type=script&lang=js"
export * from "./dataProduct.vue?vue&type=script&lang=js"
import style0 from "./dataProduct.vue?vue&type=style&index=0&id=9e6013d8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6013d8",
  null
  
)

export default component.exports